<label class="hvac-toggle">
    <div class="hvac-toggle-label">
        <p class="hvac-p-sm" [ngClass]="{'hvac-toggle-label-active': !isToggled}">{{offLabel}}</p>
        <p class="hvac-p-sm" [ngClass]="{'hvac-toggle-label-active': isToggled}">{{onLabel}}</p>
    </div>
    <input type="checkbox" [checked]="isToggled" (change)="changeToggle($event)">
    <span class="hvac-slider round"></span>
</label>
